import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 1EC70A02-36D5-4C3B-A721-018653864C6D
 * name square-medium-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-medium-outline.svg
 * tags
 * - Shape 
 */
export const SquareMediumOutlineIcon = createSvgIcon(<><path d="M14,10V14H10V10H14M16,8H8V16H16V8Z" /></>, 'SquareMediumOutlineIcon');
export default SquareMediumOutlineIcon